var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDigitalImg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 71,
    viewBox: "0 0 81 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5585 35.6612L15.4673 37.7526H7.17857C6.52494 37.7526 5.99503 38.2823 5.99503 38.9361C5.99503 39.5899 6.52494 40.1197 7.17857 40.1197H15.9574C16.2713 40.1197 16.5724 39.995 16.7943 39.7731L19.2322 37.335C19.6944 36.8728 19.6944 36.1236 19.2322 35.6613C18.7702 35.1991 18.0207 35.1991 17.5585 35.6612Z",
    fill: "url(#paint0_linear_1168_1194)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.188 43.3547C15.188 42.7009 14.6581 42.1711 14.0044 42.1711H7.17857C6.52494 42.1711 5.99503 42.7009 5.99503 43.3547C5.99503 44.0085 6.52494 44.5382 7.17857 44.5382H14.0043C14.6581 44.5382 15.188 44.0083 15.188 43.3547Z",
    fill: "url(#paint1_linear_1168_1194)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.41023 46.5897C6.7566 46.5897 6.22669 47.1194 6.22669 47.7732C6.22669 48.427 6.7566 48.9568 7.41023 48.9568H11.211C11.8646 48.9568 12.3945 48.427 12.3945 47.7732C12.3945 47.1194 11.8646 46.5897 11.211 46.5897H7.41023Z",
    fill: "url(#paint2_linear_1168_1194)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8238 0.515869H1.97257C0.884815 0.515869 0 1.40068 0 2.48844V55.3533C0 56.441 0.884815 57.3258 1.97257 57.3258H16.8786C17.5322 57.3258 18.0621 56.7961 18.0621 56.1423C18.0621 55.4885 17.5322 54.9587 16.8786 54.9587H2.36708V10.4526H38.2124C38.8661 10.4526 39.396 9.92281 39.396 9.26902C39.396 8.61523 38.8661 8.08548 38.2124 8.08548H2.36708V2.88295H78.4293V8.08548H43.8237C43.17 8.08548 42.6401 8.61523 42.6401 9.26902C42.6401 9.92281 43.17 10.4526 43.8237 10.4526H78.4293V30.0226C78.4293 30.6764 78.9592 31.2062 79.6128 31.2062C80.2665 31.2062 80.7964 30.6764 80.7964 30.0226V2.48844C80.7964 1.40068 79.9116 0.515869 78.8238 0.515869Z",
    fill: "url(#paint3_linear_1168_1194)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6128 34.5229C78.9595 34.5229 78.4293 35.0532 78.4293 35.7065V54.9587H22.7603C22.107 54.9587 21.5767 55.489 21.5767 56.1423C21.5767 56.7956 22.107 57.3258 22.7603 57.3258H33.4642V61.9022H32.8235C29.2997 61.9022 26.4324 64.7695 26.4324 68.2933C26.4324 69.3806 27.3177 70.2659 28.405 70.2659H35.5394C36.1927 70.2659 36.7229 69.7356 36.7229 69.0823C36.7229 68.429 36.1927 67.8988 35.5394 67.8988H28.8184C29.0173 65.8647 30.7373 64.2693 32.8235 64.2693H47.9728C50.059 64.2693 51.7791 65.8647 51.978 67.8988H41.0625C40.4077 67.8988 39.879 68.429 39.879 69.0823C39.879 69.7356 40.4077 70.2659 41.0625 70.2659H52.3914C53.4787 70.2659 54.364 69.3806 54.364 68.2933C54.364 64.7695 51.4966 61.9022 47.9728 61.9022H47.3322V57.3258H78.8238C79.9111 57.3258 80.7964 56.4405 80.7964 55.3533V35.7065C80.7964 35.0532 80.2662 34.5229 79.6128 34.5229ZM44.9651 61.9022H35.8313V57.3258H44.9651V61.9022Z",
    fill: "url(#paint4_linear_1168_1194)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1458 4.3032C11.4922 4.3032 10.9631 4.83295 10.9631 5.48674C10.9631 6.14053 11.4938 6.67028 12.1474 6.67028C12.801 6.67028 13.3309 6.14053 13.3309 5.48674C13.3309 4.83295 12.801 4.3032 12.1474 4.3032H12.1458Z",
    fill: "url(#paint5_linear_1168_1194)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.88 4.3032C16.2263 4.3032 15.6972 4.83295 15.6972 5.48674C15.6972 6.14053 16.2279 6.67028 16.8816 6.67028C17.5352 6.67028 18.0651 6.14053 18.0651 5.48674C18.0651 4.83295 17.5352 4.3032 16.8816 4.3032H16.88Z",
    fill: "url(#paint6_linear_1168_1194)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.41165 4.3032C6.75802 4.3032 6.2289 4.83295 6.2289 5.48674C6.2289 6.14053 6.7596 6.67028 7.41323 6.67028C8.06686 6.67028 8.59677 6.14053 8.59677 5.48674C8.59677 4.83295 8.06686 4.3032 7.41323 4.3032H7.41165Z",
    fill: "url(#paint7_linear_1168_1194)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6054 37.8511V27.5606C55.9799 27.0698 56.9678 25.7537 56.9678 24.2135C56.9678 22.2536 55.3723 20.6597 53.4108 20.6597C52.565 20.6597 51.787 20.9564 51.1763 21.4519L43.7926 16.7998C43.8557 16.5379 43.8888 16.2633 43.8888 15.9808C43.8888 14.0224 42.2934 12.427 40.3335 12.427C38.372 12.427 36.7766 14.0224 36.7766 15.9808C36.7766 16.2696 36.8113 16.5489 36.876 16.8172L29.6138 21.4472C29.0031 20.9548 28.2282 20.6597 27.3856 20.6597C25.424 20.6597 23.8286 22.2536 23.8286 24.2135C23.8286 25.7616 24.826 27.0808 26.2115 27.5669V37.8447C24.826 38.3292 23.8286 39.65 23.8286 41.1981C23.8286 43.158 25.424 44.7519 27.3856 44.7519C28.1635 44.7519 28.8847 44.4994 29.4717 44.0733L36.8397 48.7696C36.7986 48.9827 36.7766 49.2036 36.7766 49.4292C36.7766 51.3892 38.372 52.983 40.3335 52.983C42.2934 52.983 43.8888 51.3892 43.8888 49.4292C43.8888 49.2099 43.8683 48.9953 43.8305 48.787L51.3183 44.0702C51.9069 44.4978 52.6297 44.7519 53.4108 44.7519C55.3723 44.7519 56.9678 43.158 56.9678 41.1981C56.9678 39.6563 55.9799 38.3418 54.6054 37.8511ZM40.3335 14.7941C40.9884 14.7941 41.5218 15.3275 41.5218 15.9808C41.5218 16.6357 40.9884 17.1691 40.3335 17.1691C39.677 17.1691 39.1436 16.6357 39.1436 15.9808C39.1436 15.3275 39.677 14.7941 40.3335 14.7941ZM30.8604 23.4592L38.17 18.7992C38.7696 19.26 39.5192 19.5362 40.3335 19.5362C41.1525 19.5362 41.9068 19.2568 42.5096 18.7897L49.9344 23.4671C49.8823 23.707 49.8555 23.9563 49.8555 24.2135C49.8555 24.5007 49.8902 24.78 49.9549 25.0483L42.5791 29.6941C41.951 29.1844 41.1588 28.8909 40.3335 28.8909C39.5097 28.8909 38.7207 29.1828 38.0958 29.6862L30.8399 25.0562C30.9046 24.7863 30.9409 24.5039 30.9409 24.2135C30.9409 23.9547 30.9125 23.7022 30.8604 23.4592ZM41.5218 32.4446C41.5218 33.1011 40.99 33.6313 40.3351 33.6313C39.6786 33.6313 39.1484 33.1011 39.1484 32.4446C39.1484 31.7898 39.6786 31.2579 40.3351 31.2579C40.99 31.2579 41.5218 31.7898 41.5218 32.4446ZM27.3856 42.3848C26.7291 42.3848 26.1957 41.853 26.1957 41.1981C26.1957 40.5432 26.7291 40.0114 27.3856 40.0114C28.0404 40.0114 28.5738 40.5432 28.5738 41.1981C28.5738 41.853 28.0404 42.3848 27.3856 42.3848ZM27.3856 25.4002C26.7291 25.4002 26.1957 24.8668 26.1957 24.2135C26.1957 23.5586 26.7291 23.0268 27.3856 23.0268C28.0404 23.0268 28.5738 23.5586 28.5738 24.2135C28.5738 24.8668 28.0404 25.4002 27.3856 25.4002ZM30.8178 42.1244C30.8983 41.8293 30.9409 41.5185 30.9409 41.1981C30.9409 39.6563 29.9546 38.3418 28.5786 37.8511V27.5606C28.9273 27.4359 29.2524 27.2576 29.5412 27.0366L36.8555 31.703C36.8034 31.946 36.7766 32.1937 36.7766 32.4446C36.7766 33.988 37.7676 35.3041 39.1484 35.7933V46.079C38.7365 46.2258 38.3593 46.4451 38.0327 46.7229L30.8178 42.1244ZM40.3335 50.6159C39.677 50.6159 39.1436 50.0841 39.1436 49.4292C39.1436 48.7759 39.677 48.2425 40.3335 48.2425C40.9884 48.2425 41.5218 48.7759 41.5218 49.4292C41.5218 50.0841 40.9884 50.6159 40.3335 50.6159ZM49.8555 41.1981C49.8555 41.5169 49.8981 41.8246 49.977 42.1181L42.6469 46.7339C42.3171 46.4499 41.9336 46.2258 41.5154 46.079V35.7964C42.8962 35.3072 43.8888 33.9896 43.8888 32.4446C43.8888 32.1969 43.8636 31.9523 43.8131 31.714L51.2489 27.0319C51.5456 27.2592 51.8785 27.4406 52.2383 27.5669V37.8447C50.8512 38.3292 49.8555 39.65 49.8555 41.1981ZM53.4108 42.3848C52.7559 42.3848 52.2225 41.853 52.2225 41.1981C52.2225 40.5432 52.7559 40.0114 53.4108 40.0114C54.0673 40.0114 54.6007 40.5432 54.6007 41.1981C54.6007 41.853 54.0673 42.3848 53.4108 42.3848ZM53.4108 25.4002C52.7559 25.4002 52.2225 24.8668 52.2225 24.2135C52.2225 23.5586 52.7559 23.0268 53.4108 23.0268C54.0673 23.0268 54.6007 23.5586 54.6007 24.2135C54.6007 24.8668 54.0673 25.4002 53.4108 25.4002Z",
    fill: "url(#paint8_linear_1168_1194)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7944 25.6383C16.5724 25.4165 16.2715 25.2918 15.9576 25.2918H7.17857C6.52494 25.2918 5.99503 25.8216 5.99503 26.4753C5.99503 27.1291 6.52494 27.6589 7.17857 27.6589H15.4673L17.5585 29.7501C17.7896 29.9811 18.0925 30.0967 18.3954 30.0967C18.6982 30.0967 19.0012 29.9811 19.2322 29.7501C19.6944 29.2877 19.6944 28.5385 19.2322 28.0763L16.7944 25.6383Z",
    fill: "url(#paint9_linear_1168_1194)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M7.17857 23.2403H14.0043C14.6579 23.2403 15.1878 22.7106 15.1878 22.0568C15.1878 21.403 14.6579 20.8732 14.0043 20.8732H7.17857C6.52494 20.8732 5.99503 21.403 5.99503 22.0568C5.99503 22.7106 6.52494 23.2403 7.17857 23.2403Z",
    fill: "url(#paint10_linear_1168_1194)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M7.41023 18.8218H11.211C11.8646 18.8218 12.3945 18.292 12.3945 17.6382C12.3945 16.9844 11.8646 16.4547 11.211 16.4547H7.41023C6.7566 16.4547 6.22669 16.9844 6.22669 17.6382C6.22669 18.292 6.75644 18.8218 7.41023 18.8218Z",
    fill: "url(#paint11_linear_1168_1194)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M61.564 37.3349L64.0019 39.773C64.2238 39.9948 64.5249 40.1195 64.8388 40.1195H73.6177C74.2713 40.1195 74.8012 39.5898 74.8012 38.936C74.8012 38.2822 74.2713 37.7524 73.6177 37.7524H65.3289L63.2377 35.661C62.7756 35.199 62.0262 35.199 61.564 35.661C61.1018 36.1236 61.1018 36.8728 61.564 37.3349Z",
    fill: "url(#paint12_linear_1168_1194)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6178 42.1711H66.7921C66.1385 42.1711 65.6086 42.7009 65.6086 43.3547C65.6086 44.0085 66.1385 44.5382 66.7921 44.5382H73.6178C74.2714 44.5382 74.8014 44.0085 74.8014 43.3547C74.8014 42.7009 74.2714 42.1711 73.6178 42.1711Z",
    fill: "url(#paint13_linear_1168_1194)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3861 46.5897H69.5854C68.9318 46.5897 68.4019 47.1194 68.4019 47.7732C68.4019 48.427 68.9318 48.9568 69.5854 48.9568H73.3861C74.0398 48.9568 74.5697 48.427 74.5697 47.7732C74.5697 47.1194 74.0399 46.5897 73.3861 46.5897Z",
    fill: "url(#paint14_linear_1168_1194)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0019 25.6383L61.564 28.0761C61.1018 28.5385 61.1018 29.2877 61.564 29.75C61.795 29.981 62.098 30.0965 62.4008 30.0965C62.7037 30.0965 63.0067 29.981 63.2377 29.75L65.3289 27.6587H73.6177C74.2713 27.6587 74.8012 27.129 74.8012 26.4752C74.8012 25.8214 74.2713 25.2916 73.6177 25.2916H64.8388C64.5249 25.2918 64.224 25.4165 64.0019 25.6383Z",
    fill: "url(#paint15_linear_1168_1194)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6084 22.0568C65.6084 22.7106 66.1383 23.2403 66.7919 23.2403H73.6177C74.2713 23.2403 74.8012 22.7106 74.8012 22.0568C74.8012 21.403 74.2713 20.8732 73.6177 20.8732H66.7919C66.1383 20.8732 65.6084 21.403 65.6084 22.0568Z",
    fill: "url(#paint16_linear_1168_1194)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3861 18.8218C74.0398 18.8218 74.5697 18.292 74.5697 17.6382C74.5697 16.9844 74.0398 16.4547 73.3861 16.4547H69.5854C68.9318 16.4547 68.4019 16.9844 68.4019 17.6382C68.4019 18.292 68.9318 18.8218 69.5854 18.8218H73.3861Z",
    fill: "url(#paint17_linear_1168_1194)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1168_1194",
    x1: 81.4258,
    y1: 15.7624,
    x2: -24.6464,
    y2: 25.9453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF36A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1168_1194",
    x1: 81.4258,
    y1: 15.7624,
    x2: -24.6464,
    y2: 25.9453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF36A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1168_1194",
    x1: 81.4258,
    y1: 15.7624,
    x2: -24.6464,
    y2: 25.9453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF36A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1168_1194",
    x1: 81.4258,
    y1: 15.7624,
    x2: -24.6464,
    y2: 25.9453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF36A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1168_1194",
    x1: 81.4258,
    y1: 15.7624,
    x2: -24.6464,
    y2: 25.9453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF36A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1168_1194",
    x1: 81.4258,
    y1: 15.7624,
    x2: -24.6464,
    y2: 25.9453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF36A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1168_1194",
    x1: 81.4258,
    y1: 15.7624,
    x2: -24.6464,
    y2: 25.9453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF36A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1168_1194",
    x1: 81.4258,
    y1: 15.7624,
    x2: -24.6464,
    y2: 25.9453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF36A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1168_1194",
    x1: 81.4258,
    y1: 15.7624,
    x2: -24.6464,
    y2: 25.9453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF36A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1168_1194",
    x1: 81.4258,
    y1: 15.7624,
    x2: -24.6464,
    y2: 25.9453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF36A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1168_1194",
    x1: 81.4258,
    y1: 15.7624,
    x2: -24.6464,
    y2: 25.9453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF36A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1168_1194",
    x1: 81.4258,
    y1: 15.7624,
    x2: -24.6464,
    y2: 25.9453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF36A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1168_1194",
    x1: 81.4258,
    y1: 15.7624,
    x2: -24.6464,
    y2: 25.9453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF36A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1168_1194",
    x1: 81.4258,
    y1: 15.7624,
    x2: -24.6464,
    y2: 25.9453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF36A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1168_1194",
    x1: 81.4258,
    y1: 15.7624,
    x2: -24.6464,
    y2: 25.9453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF36A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1168_1194",
    x1: 81.4258,
    y1: 15.7624,
    x2: -24.6464,
    y2: 25.9453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF36A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1168_1194",
    x1: 81.4258,
    y1: 15.7624,
    x2: -24.6464,
    y2: 25.9453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF36A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1168_1194",
    x1: 81.4258,
    y1: 15.7624,
    x2: -24.6464,
    y2: 25.9453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF36A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40FBFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalImg1);
export default __webpack_public_path__ + "static/media/digital-img-1.3d30ea063bfb5a1a11818e2ffb5936ee.svg";
export { ForwardRef as ReactComponent };